import type { SRT_ColumnPinningState } from '@/shared/components/master-table'
import type { Updater } from '@tanstack/react-table'
import type { StateCreator } from 'zustand'

export type ColumnConfigSliceShape = {
	columnVisibility: Record<string, boolean>
	columnPinning: SRT_ColumnPinningState
	columnOrder: string[]
	columnSizing: Record<string, number>

	setColumnVisibility(modifier: Updater<Record<string, boolean>>): void
	setColumnPinning(modifier: Updater<SRT_ColumnPinningState>): void
	setColumnOrder(order: Updater<string[]>): void
	setColumnSizing(modifier: Updater<Record<string, number>>): void
}

export const createColumnConfigSlice: StateCreator<ColumnConfigSliceShape> = (
	set
) => ({
	columnVisibility: {},
	columnPinning: { left: [], right: [] },
	columnOrder: [],
	columnSizing: {},
	setColumnVisibility: (modifier) =>
		set((state) => ({
			columnVisibility:
				typeof modifier == 'function'
					? modifier(state.columnVisibility)
					: modifier,
		})),
	setColumnPinning: (modifier) =>
		set((state) => ({
			columnPinning:
				typeof modifier == 'function'
					? modifier(state.columnPinning)
					: modifier,
		})),
	setColumnOrder: (modifier) =>
		set((state) => ({
			columnOrder:
				typeof modifier == 'function' ? modifier(state.columnOrder) : modifier,
		})),
	setColumnSizing: (modifier) =>
		set((state) => ({
			columnSizing:
				typeof modifier == 'function' ? modifier(state.columnSizing) : modifier,
		})),
})
